import { render, staticRenderFns } from "./AlertNotificationForm.vue?vue&type=template&id=436216e6"
import script from "./AlertNotificationForm.vue?vue&type=script&lang=js"
export * from "./AlertNotificationForm.vue?vue&type=script&lang=js"
import style0 from "./AlertNotificationForm.vue?vue&type=style&index=0&id=436216e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports